import type { FieldValues, Path, UseFormRegister } from 'react-hook-form';
import styled from 'styled-components';
import { BasicInputStyles } from './BasicInput';

type InputCurrencyProps<Fields extends FieldValues> = {
  name: Path<Fields>;
  id?: string;
  value?: string | number;
  autoFocus?: boolean;
  defaultValue?: string | number;
  disabled?: boolean;
  errorMessage?: string;
  inputSize?: string;
  label?: string;
  register?: UseFormRegister<Fields>;
  required?: boolean;
  changeFunction?: (e: React.ChangeEvent<HTMLInputElement>) => void;
};

const Wrapper = styled.div`
  position: relative;
  &::before {
    content: '$';
    position: absolute;
    display: block;
    top: 50%;
    left: 10px;
    transform: translateY(-51%);
  }
`;

const Input = styled(BasicInputStyles)`
  padding-left: 20px;
`;

const InputCurrency = <Fields extends FieldValues>({
  id,
  errorMessage,
  required,
  disabled,
  value,
  name,
  inputSize = 'md',
  defaultValue,
  changeFunction,
  autoFocus,
  ...rest
}: InputCurrencyProps<Fields>) => {
  // const decimalDigitPattern = '^\\d+(\\.\\d+)?$';
  const { register = () => undefined } = rest;

  return (
    <Wrapper>
      <Input
        id={id ? `${id}-input-currency` : undefined}
        type="number"
        defaultValue={defaultValue}
        value={value}
        required={required}
        disabled={disabled}
        step="0.01"
        inputSize={inputSize}
        autoFocus={autoFocus}
        // pattern={decimalDigitPattern}
        errorMessage={errorMessage}
        {...register(name, {
          setValueAs: (value) =>
            value === undefined || value === '' ? undefined : parseFloat(value),
          onChange: changeFunction
        })}
      />
    </Wrapper>
  );
};

export { InputCurrency };
